import { ref, watch } from "vue"

export const setupContainer = () => {
  const element = ref(null)
  const width = ref(undefined)
  const height = ref(undefined)
  const isResizing = ref(false)

  let isResizingTimeoutId = undefined
  const observer = new ResizeObserver(records => {
    for (const record of records) {
      if (record.target !== element.value) continue

      const { width: newWidth, height: newHeight } = record.target.getBoundingClientRect()

      if (isResizingTimeoutId) {
        clearTimeout(isResizingTimeoutId)
      }

      isResizing.value = true

      width.value = newWidth
      height.value = newHeight

      isResizingTimeoutId = setTimeout(() => {
        isResizing.value = false
      }, 100)
    }
  })

  watch(
    element,
    (element, oldElement) => {
      if (oldElement) {
        observer.unobserve(oldElement)
      }

      if (!element) return

      observer.observe(element)
    },
    { immediate: true }
  )

  return {
    element,
    width,
    height,
    isResizing
  }
}
